import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode, c as config } from './ionic-global.js';
import { s as sanitizeDOMString } from './index3.js';
import { d as defineCustomElement$2 } from './spinner.js';
var infiniteScrollContentIosCss = "ion-infinite-scroll-content{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;min-height:84px;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.infinite-loading{margin-left:0;margin-right:0;margin-top:0;margin-bottom:32px;display:none;width:100%}.infinite-loading-text{margin-left:32px;margin-right:32px;margin-top:4px;margin-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.infinite-loading-text{margin-left:unset;margin-right:unset;-webkit-margin-start:32px;margin-inline-start:32px;-webkit-margin-end:32px;margin-inline-end:32px}}.infinite-scroll-loading ion-infinite-scroll-content>.infinite-loading{display:block}.infinite-scroll-content-ios .infinite-loading-text{color:var(--ion-color-step-600, #666666)}.infinite-scroll-content-ios .infinite-loading-spinner .spinner-lines-ios line,.infinite-scroll-content-ios .infinite-loading-spinner .spinner-lines-small-ios line,.infinite-scroll-content-ios .infinite-loading-spinner .spinner-crescent circle{stroke:var(--ion-color-step-600, #666666)}.infinite-scroll-content-ios .infinite-loading-spinner .spinner-bubbles circle,.infinite-scroll-content-ios .infinite-loading-spinner .spinner-circles circle,.infinite-scroll-content-ios .infinite-loading-spinner .spinner-dots circle{fill:var(--ion-color-step-600, #666666)}";
var infiniteScrollContentMdCss = "ion-infinite-scroll-content{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;min-height:84px;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.infinite-loading{margin-left:0;margin-right:0;margin-top:0;margin-bottom:32px;display:none;width:100%}.infinite-loading-text{margin-left:32px;margin-right:32px;margin-top:4px;margin-bottom:0}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){.infinite-loading-text{margin-left:unset;margin-right:unset;-webkit-margin-start:32px;margin-inline-start:32px;-webkit-margin-end:32px;margin-inline-end:32px}}.infinite-scroll-loading ion-infinite-scroll-content>.infinite-loading{display:block}.infinite-scroll-content-md .infinite-loading-text{color:var(--ion-color-step-600, #666666)}.infinite-scroll-content-md .infinite-loading-spinner .spinner-lines-md line,.infinite-scroll-content-md .infinite-loading-spinner .spinner-lines-small-md line,.infinite-scroll-content-md .infinite-loading-spinner .spinner-crescent circle{stroke:var(--ion-color-step-600, #666666)}.infinite-scroll-content-md .infinite-loading-spinner .spinner-bubbles circle,.infinite-scroll-content-md .infinite-loading-spinner .spinner-circles circle,.infinite-scroll-content-md .infinite-loading-spinner .spinner-dots circle{fill:var(--ion-color-step-600, #666666)}";

var InfiniteScrollContent = /*#__PURE__*/function (_HTMLElement) {
  _inherits(InfiniteScrollContent, _HTMLElement);

  var _super = _createSuper(InfiniteScrollContent);

  function InfiniteScrollContent() {
    var _this;

    _classCallCheck(this, InfiniteScrollContent);

    _this = _super.call(this);

    _this.__registerHost();

    return _this;
  }

  _createClass(InfiniteScrollContent, [{
    key: "componentDidLoad",
    value: function componentDidLoad() {
      if (this.loadingSpinner === undefined) {
        var mode = getIonMode(this);
        this.loadingSpinner = config.get('infiniteLoadingSpinner', config.get('spinner', mode === 'ios' ? 'lines' : 'crescent'));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _class;

      var mode = getIonMode(this);
      return h(Host, {
        class: (_class = {}, _defineProperty(_class, mode, true), _defineProperty(_class, "infinite-scroll-content-".concat(mode), true), _class)
      }, h("div", {
        class: "infinite-loading"
      }, this.loadingSpinner && h("div", {
        class: "infinite-loading-spinner"
      }, h("ion-spinner", {
        name: this.loadingSpinner
      })), this.loadingText && h("div", {
        class: "infinite-loading-text",
        innerHTML: sanitizeDOMString(this.loadingText)
      })));
    }
  }], [{
    key: "style",
    get: function get() {
      return {
        ios: infiniteScrollContentIosCss,
        md: infiniteScrollContentMdCss
      };
    }
  }]);

  return InfiniteScrollContent;
}(HTMLElement);

InfiniteScrollContent = /*@__PURE__*/proxyCustomElement(InfiniteScrollContent, [32, "ion-infinite-scroll-content", {
  "loadingSpinner": [1025, "loading-spinner"],
  "loadingText": [1, "loading-text"]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-infinite-scroll-content", "ion-spinner"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-infinite-scroll-content":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, InfiniteScrollContent);
        }

        break;

      case "ion-spinner":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }

        break;
    }
  });
}

var IonInfiniteScrollContent = InfiniteScrollContent;
var defineCustomElement = defineCustomElement$1;
export { IonInfiniteScrollContent, defineCustomElement };